module.exports = __webpack_public_path__ + "static/media/plus.e5c792b0.jpg";